import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { ConstantService } from "../../../../components/common/utils/constant.service";
import { ClienteLogin, Cliente, ClienteXCiudad, ConsultaCliente } from "../../../login/cliente_login";
import { Headers, Http, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { BusquedaSiniestralidad, PolizaEntity } from '../../entities/polizas_cliente_entity';
import { PlanVam, MovimientosVamEntity, ResultadoMovmientosPorPlan, ObjMultiSelectPolizas, BusquedaFacturacion, CombosFacturacion, ConsultaFacturacion } from '../../entities/vam_entities';
import { PolizaVAM, ConsultaSiniestralidad } from '../../entities/vam_entities';
import { ComboBox, ObjMultiSelect } from '../../../../components/common/utils/combobox';
import { Archivo } from '../../../../components/common/utils/entities/util_entity';

declare var jQuery: any;

@Injectable()
export class MovimientosVamService {
    private userEmpresa: ClienteXCiudad;
    private url = "movimientos";

    constructor(private authHttp: AuthHttp, private sessionStorageService: SessionStorageService) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
    }

    consultaPlanes(poliza: PolizaEntity): Observable<PlanVam[]>{
        let body = JSON.stringify(poliza);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultarPlanesVam", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    consultaMovimientos(busqueda: MovimientosVamEntity): Observable<ResultadoMovmientosPorPlan[]>{
        let body = JSON.stringify(busqueda);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/movimientosVam", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    consultaSiniestralidad(busqueda: MovimientosVamEntity): Observable<ConsultaSiniestralidad>{
        let body = JSON.stringify(busqueda);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/ConsultarSiniestralidad", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    consultaPlanesPoliza(poliza: PolizaEntity): Observable<ObjMultiSelectPolizas[]>{
        let body = JSON.stringify(poliza);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultaPlanesPolizaVam", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    getClientes(parametros: ConsultaCliente): Observable<ComboBox[]> {
        let body = JSON.stringify(parametros);
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/ConsultaClientes/", body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }
    getTipoNegocio(parametros: BusquedaFacturacion): Observable<ComboBox[]> {
        let body = JSON.stringify(parametros);
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/ConsultaTipoNegocio/", body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }
    getCombos(parametros: BusquedaFacturacion): Observable<CombosFacturacion> {
        let body = JSON.stringify(parametros);
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/ConsultarCombos/", body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }
    getAseguradora(parametros: BusquedaSiniestralidad): Observable<ComboBox[]> {
        let body = JSON.stringify(parametros);
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/ConsultarAseguradora/", body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }
    getConsultarDetalleMovimientos(parametros: BusquedaFacturacion): Observable<ConsultaFacturacion> {
        let body = JSON.stringify(parametros);
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/ConsultarDetalleMovimientos/", body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }
    getValidarFacturacion(parametros: BusquedaFacturacion): Observable<BusquedaFacturacion> {
        let body = JSON.stringify(parametros);
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/ValidarFacturacion/", body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }
    ConsultarAdjuntosMovimientos(carcod: number): Observable<Archivo[]> {
        return this.authHttp.get(this.url + '/ConsultarAdjuntosMovimientos/' + carcod)
            .map(this.extractData)
            .catch(this.handleError);
    }
    getArchivo(consulta: Archivo): Observable<any> {
        let body = JSON.stringify(consulta);
        let headers = new Headers();
        if (consulta.Extension.toUpperCase() == "XLSX") {
          headers = new Headers({
            "Content-Type": "application/json",
            //
            Accept:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
        } else {
          headers = new Headers({
            "Content-Type": "application/json",
            //Authorization: "Token " + sessionStorage.getItem("Token"),
            Accept: "application/pdf"
          });
        }
        let options = new RequestOptions({ headers: headers });
        options.responseType = ResponseContentType.Blob;
        return this.authHttp
          .post(this.url + "/getArchivoMovimiento", body, options)
          .map(response => response)
          .catch(this.handleError);
      }
    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/vamEmpresa/movimientos/movimientosVam.service.ts